import { ChangeDetectorRef, Component, inject } from "@angular/core";
import { ImageToUpload } from "../../berichte.component";
import {
  HttpClient,
  HttpEvent,
  HttpEventType,
  HttpParams,
  HttpRequest,
} from "@angular/common/http";
import { catchError, delay, last, map } from "rxjs/operators";
import { of } from "rxjs";

@Component({
  templateUrl: "./image.component.html",
  styleUrls: ["./image.component.scss"],
  standalone: false,
})
export class BerichtImageUploadProgressItemComponent {
  private _http = inject(HttpClient);
  private _cdr = inject(ChangeDetectorRef);

  data: ImageToUpload;

  progress: number;
  eventType: number;

  public _post() {
    const formData = new FormData();
    formData.append("data", this.data.file);

    const queryParams = new HttpParams()
      .set("formularID", this.data.formularID)
      .set("imageID", this.data.id);

    const req = new HttpRequest(
      "POST",
      "/api/Formular/Formulare/Images",
      formData,
      { params: queryParams, reportProgress: true },
    );

    return this._http.request(req).pipe(
      map((event) => {
        this._handleEvent(event);
        this._cdr.detectChanges();
      }),
      last(),
      delay(1500),
      catchError((error) => {
        console.error(error);
        return of(false);
      }),
    );
  }

  private _handleEvent(event: HttpEvent<any>) {
    this.eventType = event.type;
    switch (event.type) {
      case HttpEventType.Sent:
        break;

      case HttpEventType.UploadProgress:
        this.progress = this._getProgress(event);
        break;

      case HttpEventType.DownloadProgress:
        this.progress = this._getProgress(event);
        break;

      case HttpEventType.Response:
        return true;
    }
  }

  private _getProgress(event) {
    return event.total ? Math.round((100 * event.loaded) / event.total) : 0;
  }
  public getProgressBarMode() {
    switch (this.eventType) {
      case 0:
        return "indeterminate";
      case 1:
      case 2:
      case 3:
        return "determinate";
    }
  }
}
